import React from 'react';
import PropTypes from 'prop-types';
import keygen from '~helpers/keygen';

export default function TwitterIcon({ width = 13, height = 12 }) {
  const key = keygen();

  return (
    <svg
      width="1em"
      height="1em"
      viewBox={`0 0 ${width} ${height}`}
      fill="currentcolor"
      aria-labelledby={`twitterIcon_${key}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={`twitterIcon_${key}`}>TwitterIcon</title>
      <path d="M9.97574 0H11.9181L7.67469 4.84989L12.6667 11.4495H8.75802L5.69659 7.44685L2.19363 11.4495H0.250147L4.78881 6.26203L0 0H4.0079L6.7752 3.65856L9.97574 0ZM9.29408 10.287H10.3703L3.42314 1.1015H2.26822L9.29408 10.287Z" />
    </svg>
  );
}

TwitterIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
